import { StarIcon } from './icons/StarIcon';

export default function ReviewCard({ result }) {
  const sentimentColor = {
    positive: 'text-green-600',
    neutral: 'text-slate-600',
    negative: 'text-red-600',
  }[result.sentiment] || 'text-slate-600';

  const sentimentBg = {
    positive: 'bg-green-50 border-green-200',
    neutral: 'bg-slate-50 border-slate-200',
    negative: 'bg-red-50 border-red-200',
  }[result.sentiment] || 'bg-slate-50 border-slate-200';

  return (
    <a
      href={result.url}
      target="_blank"
      rel="noopener noreferrer"
      className="card p-6 cursor-pointer group h-full flex flex-col"
    >
      {/* Image */}
      <div className="mb-4 aspect-video bg-slate-100 rounded-lg overflow-hidden">
        <img
          src={result.image}
          alt={result.title}
          className="w-full h-full object-cover group-hover:scale-105 transition-transform duration-300"
        />
      </div>

      {/* Source Badge */}
      <div className="flex items-center justify-between mb-3">
        <span className="text-xs font-semibold text-slate-600 uppercase tracking-wide">
          {result.sourceName}
        </span>
        {result.verified && (
          <span className="text-xs bg-green-100 text-green-700 px-2 py-1 rounded font-medium">
            Verified
          </span>
        )}
      </div>

      {/* Title */}
      <h3 className="text-lg font-bold text-slate-900 mb-2 line-clamp-2 group-hover:text-sky-600 transition-colors">
        {result.title}
      </h3>

      {/* Rating */}
      <div className="flex items-center gap-2 mb-3">
        <div className="flex">
          {Array.from({ length: 5 }).map((_, i) => (
            <StarIcon
              key={i}
              filled={i < Math.floor(result.rating)}
              half={i === Math.floor(result.rating) && result.rating % 1 !== 0}
            />
          ))}
        </div>
        <span className="text-sm font-semibold text-slate-700">
          {result.rating.toFixed(1)}
        </span>
        <span className="text-xs text-slate-500">
          ({result.reviewCount?.toLocaleString() || '0'} reviews)
        </span>
      </div>

      {/* Excerpt */}
      <p className="text-sm text-slate-600 mb-4 line-clamp-3 flex-grow">
        {result.excerpt}
      </p>

      {/* Sentiment & CTA */}
      <div className="flex items-center justify-between pt-4 border-t border-slate-200">
        <span className={`text-xs font-semibold uppercase tracking-wide ${sentimentColor}`}>
          {result.sentiment === 'positive' && '✓ Positive'}
          {result.sentiment === 'neutral' && '○ Mixed'}
          {result.sentiment === 'negative' && '✕ Negative'}
        </span>
        <span className="text-xs text-sky-600 font-semibold group-hover:text-sky-700">
          Read More →
        </span>
      </div>
    </a>
  );
}
